import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import Colors from '../../utils/color';
import IntentsSectionGrouped from './IntentsSectionGrouped';
import { OmniBarCompact } from './OmniBarCompact';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  bar: {
    display: 'flex',
    alignItems: 'stretch',
    gap: spacing(1),
    padding: spacing(1),
    backgroundColor: Colors.porcelain,
  },
  quickResponse: {
    // Grows to fill whatever the (content-sized) intents row leaves — the agent's
    // primary input stays large without stretching the intent buttons.
    flex: '1 1 0',
    minWidth: 280,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Colors.white,
    border: `${spacing(0.125)} solid ${Colors.alto}`,
    borderRadius: spacing(1),
    padding: spacing(1),
  },
  inputWrap: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
}));

/**
 * Full-width bottom action bar.
 *
 * QUICK RESPONSE -> OmniBar (customer-response input).
 * The remaining groups (CONVERSATION / ORDER FLOW / ESCALATION) are rendered
 * by IntentsSection, which groups the intent cards by section and themes each
 * with its own colour + icon.
 */
const BottomActionBar = () => {
  const classes = useStyles();

  return (
    <div className={classes.bar}>
      <div className={classes.quickResponse}>
        <div className={classes.inputWrap}>
          <OmniBarCompact />
        </div>
      </div>
      <IntentsSectionGrouped />
    </div>
  );
};

export default BottomActionBar;
